import ContactUsPage from "./contactUsPage";

export default ContactUsPage;